import Vue from 'vue';

export default {
  TOGGLE_ADD_TRANSLATOR_DIALOG: (state, payload) => {
    state.addTranslatorDialog = payload;
  },
  TOGGLE_TRANSLATOR_EDIT_DIALOG: (state, payload) => {
    state.translatorEditDialog = payload;
  },
  SET_ACTIVE_TRANSLATOR_ID: (state, { compId, payload }) => {
    Vue.set(state.activeTranslatorsIds, compId, payload);
  },
};



// WEBPACK FOOTER //
// ./src/store/translators/mutations.js